import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Benefits } from './components/Benefits';
import { Content } from './components/Content';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Results } from './components/Results';
import { Offer } from './components/Offer';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen bg-palomitas-cream font-sans selection:bg-palomitas-gold selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <Benefits data-id="element-4" />
      <Content data-id="element-5" />
      <Gallery data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Results data-id="element-8" />
      <Offer data-id="element-9" />
      <FinalCTA data-id="element-10" />

      {/* Simple Footer */}
      <footer className="bg-palomitas-dark border-t border-white/10 py-8 text-center text-palomitas-beige/60 text-sm" data-id="element-11">
        <div className="container mx-auto px-4" data-id="element-12">
          <p data-id="element-13">
            © {new Date().getFullYear()} Palomitas Gourmet. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs opacity-70" data-id="element-14">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}